import { render } from "./OrganizationDetails.vue?vue&type=template&id=542795a5"
import script from "./OrganizationDetails.vue?vue&type=script&lang=js"
export * from "./OrganizationDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__